import * as React from 'react';
import { Button } from '@grandvisionhq/common';
import { getButtonVariant, getButtonColor } from '../../helpers.js';

const Buttons = ({ active , items  })=>{
    if (!items || !items.length) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "site-nav-mobile__buttons"
    }, items.map((item)=>/*#__PURE__*/ React.createElement(Button, {
            key: item.label,
            "data-t": item.label,
            icon: item.parameters && item.parameters.icon,
            href: item.link && item.link.href,
            caption: item.label,
            variant: getButtonVariant(item),
            color: getButtonColor(item),
            tabIndex: active ? undefined : -1
        })
    ));
};
var Buttons$1 = Buttons;

export { Buttons$1 as default };
//# sourceMappingURL=Buttons.js.map
